export const issueRefetchQueries = ['IssueViewData', 'BopNavigationDrawerData', 'UpdateStepData', 'StepTreeData']
